/**
 * Fecha um painel, popover ou menu quando a pessoa toca em qualquer outra coisa.
 *
 * Devolve `onPointerDownCapture` para espalhar na raiz do painel. "Dentro" segue
 * a árvore do React, então um ConfirmDialog ou menu em portal aberto pelo
 * painel conta como dentro dele. `ignorar` é um seletor de quem não fecha:
 * o botão que alterna o próprio painel (senão o toque fecha e o clique reabre)
 * ou o bloco da tarefa que já está aberta. Botão direito não fecha: ele abre o
 * menu de contexto, que tem o seu próprio clique fora.
 */

import { useEffect, useRef } from "react";

export default function useCliqueFora(onFechar, { ativo = true, ignorar = "" } = {}) {
  const fechar = useRef(onFechar);
  fechar.current = onFechar;
  const toqueDeDentro = useRef(null);

  useEffect(() => {
    if (!ativo) return undefined;
    const aoTocar = (evento) => {
      if (toqueDeDentro.current === evento) return;
      if (evento.button > 0) return;
      if (ignorar && evento.target instanceof Element && evento.target.closest(ignorar)) return;
      fechar.current();
    };
    document.addEventListener("pointerdown", aoTocar);
    return () => document.removeEventListener("pointerdown", aoTocar);
  }, [ativo, ignorar]);

  return {
    onPointerDownCapture: (evento) => { toqueDeDentro.current = evento.nativeEvent; },
  };
}
